import Schema from './schema';

const policies = {
  credentials_id: { id: 'credentials_id' },
  environment: { id: 'environment' },
  excecution_mode: { id: 'excecution_mode' },
  instance_groups: { id: 'instance_groups' },
  inventory_id: { id: 'inventory_id' },
  limit: { id: 'limit' },
  name: { id: 'name' },
  playbook_id: { id: 'playbook_id' },
  proyect_id: { id: 'proyect_id' },
  revision: { id: 'revision' },
  type: { id: 'type' },
  userInteraction: { id: 'userInteraction' },
  worktemplate_id: { id: 'worktemplate_id' }
};


export default class Job extends Schema {

  constructor(values) {
    super(policies, values);

    this.setDtoDefinition({
      credentials_id: 0,
      environment: 0,
      excecution_mode: 0,
      instance_groups: 0,
      inventory_id: 0,
      limit: 0,
      name: "",
      playbook_id: 0,
      proyect_id: 0,
      revision: 0,
      type: "",
      userInteraction: "",
      worktemplate_id: ""
    });
  }

  setValues(data) {
    this.setDefaultValues(data);
    this.values = {
      ...this.dtoDefinition,
      ...this.values,
    }
  }
}
